export default __webpack_public_path__ + "static/media/handsUp.61a55e19.webp";